import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

const ChatbotAIAgents = lazy(() => import('./presentation/modules/Automations/ChatbotIA/Agents'));
const ChatbotAIAgentConfig = lazy(() => import('./presentation/modules/Automations/ChatbotIA/Agents/Configuration'));
const ChatbotAIGuides = lazy(() => import('./presentation/modules/Automations/ChatbotIA/Guides'));
const ChatbotAIManageGuide = lazy(() => import('./presentation/modules/Automations/ChatbotIA/Guides/ManageGuides'));
const ChatbotAIHistory = lazy(() => import('./presentation/modules/Automations/ChatbotIA/History'));
const ChatbotAICopilots = lazy(() => import('./presentation/modules/Automations/ChatbotIA/Copilots'));

const ChatbotAIRoutes = () => (
  <Routes>
    <Route relative="route" path="agents" element={<ProtectedRoute element={ChatbotAIAgents} />} />
    <Route relative="route" path="agents/:id/config" element={<ProtectedRoute element={ChatbotAIAgentConfig} />} />
    <Route relative="route" path="guides" element={<ProtectedRoute element={ChatbotAIGuides} />} />
    <Route relative="route" path="guides/new" element={<ProtectedRoute element={ChatbotAIManageGuide} />} />
    <Route relative="route" path="guides/:id/edit" element={<ProtectedRoute element={ChatbotAIManageGuide} />} />
    <Route relative="route" path="history" element={<ProtectedRoute element={ChatbotAIHistory} />} />
    <Route relative="route" path="copilots" element={<ProtectedRoute element={ChatbotAICopilots} />} />
  </Routes>
);

export default ChatbotAIRoutes;
